/* eslint-disable */
// prettier-ignore
import * as Types from '../../../../../../../graphql/__generated__';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type InvestorFirms_AddInvestorFirmMutationVariables = Types.Exact<{
  input: Types.CreateInvestorFirmInput;
}>;

export type InvestorFirms_AddInvestorFirmMutation = {
  readonly __typename?: 'Mutation';
  readonly createInvestorFirm?: {
    readonly __typename?: 'CreateInvestorFirmPayload';
    readonly investorFirmsGrid?: {
      readonly __typename?: 'InvestorFirmsGrid';
      readonly id: string;
      readonly firmKey?: string | null;
      readonly name: string;
      readonly firmType?: string | null;
      readonly firmSubType?: string | null;
      readonly cik1?: string | null;
      readonly cik2?: string | null;
      readonly crd?: string | null;
      readonly lei?: string | null;
      readonly factSet?: string | null;
      readonly description?: string | null;
      readonly website1?: string | null;
      readonly website2?: string | null;
      readonly address1?: string | null;
      readonly address2?: string | null;
      readonly emailAddress1?: string | null;
      readonly emailAddress2?: string | null;
      readonly phone1?: string | null;
      readonly phone2?: string | null;
      readonly fax1?: string | null;
      readonly fax2?: string | null;
      readonly status: Types.RolodexRecordStatus;
      readonly modifiedOn: string;
      readonly modifiedByUserName?: string | null;
    } | null;
  } | null;
};

export type InvestorFirms_AdminAddInvestorFirmMutationVariables = Types.Exact<{
  input: Types.AdminCreateInvestorFirmInput;
}>;

export type InvestorFirms_AdminAddInvestorFirmMutation = {
  readonly __typename?: 'Mutation';
  readonly adminCreateInvestorFirm?: {
    readonly __typename?: 'AdminCreateInvestorFirmPayload';
    readonly investorFirmsGrid?: {
      readonly __typename?: 'InvestorFirmsGrid';
      readonly id: string;
      readonly firmKey?: string | null;
      readonly name: string;
      readonly firmType?: string | null;
      readonly firmSubType?: string | null;
      readonly cik1?: string | null;
      readonly cik2?: string | null;
      readonly crd?: string | null;
      readonly lei?: string | null;
      readonly factSet?: string | null;
      readonly description?: string | null;
      readonly website1?: string | null;
      readonly website2?: string | null;
      readonly address1?: string | null;
      readonly address2?: string | null;
      readonly emailAddress1?: string | null;
      readonly emailAddress2?: string | null;
      readonly phone1?: string | null;
      readonly phone2?: string | null;
      readonly fax1?: string | null;
      readonly fax2?: string | null;
      readonly status: Types.RolodexRecordStatus;
      readonly modifiedOn: string;
      readonly modifiedByUserName?: string | null;
    } | null;
  } | null;
};

export type CrmManagement_InvestorFirms_InvestorFirmDetailQueryVariables = Types.Exact<{
  firmId: Types.Scalars['UUID']['input'];
}>;

export type CrmManagement_InvestorFirms_InvestorFirmDetailQuery = {
  readonly __typename?: 'Query';
  readonly investorFirmsGrid?: {
    readonly __typename?: 'InvestorFirmsGridCollectionSegment';
    readonly items?: ReadonlyArray<{
      readonly __typename?: 'InvestorFirmsGrid';
      readonly address1?: string | null;
      readonly address2?: string | null;
      readonly cik1?: string | null;
      readonly cik2?: string | null;
      readonly linkedCmgEntityKey?: string | null;
      readonly linkedCmgEntityName?: string | null;
      readonly crd?: string | null;
      readonly createdByUserName?: string | null;
      readonly createdOn: string;
      readonly description?: string | null;
      readonly emailAddress1?: string | null;
      readonly emailAddress2?: string | null;
      readonly factSet?: string | null;
      readonly fax1?: string | null;
      readonly fax2?: string | null;
      readonly firmKey?: string | null;
      readonly id: string;
      readonly firmSubType?: string | null;
      readonly firmType?: string | null;
      readonly isOnPlatform: boolean;
      readonly isLinked: boolean;
      readonly lei?: string | null;
      readonly modifiedByUserName?: string | null;
      readonly modifiedOn: string;
      readonly mpid?: string | null;
      readonly name: string;
      readonly phone1?: string | null;
      readonly phone2?: string | null;
      readonly status: Types.RolodexRecordStatus;
      readonly website1?: string | null;
      readonly website2?: string | null;
      readonly investorContactsCount: number;
      readonly salesCoverageCount: number;
      readonly investorContacts?: {
        readonly __typename?: 'InvestorContactsCollectionSegment';
        readonly items?: ReadonlyArray<{
          readonly __typename?: 'InvestorFirmContact';
          readonly investorEmployeeId: string;
          readonly name: string;
          readonly email1?: string | null;
        }> | null;
      } | null;
      readonly salesCoverage?: {
        readonly __typename?: 'SalesCoverageCollectionSegment';
        readonly items?: ReadonlyArray<{
          readonly __typename?: 'InvestorFirmRelationship';
          readonly employeeName?: string | null;
        }> | null;
      } | null;
    }> | null;
  } | null;
};

export type CrmManagement_InvestorFirms_AdminInvestorFirmDetailQueryVariables = Types.Exact<{
  firmId: Types.Scalars['UUID']['input'];
  tenantId: Types.Scalars['UUID']['input'];
}>;

export type CrmManagement_InvestorFirms_AdminInvestorFirmDetailQuery = {
  readonly __typename?: 'Query';
  readonly adminInvestorFirmsGrid?: {
    readonly __typename?: 'AdminInvestorFirmsGridCollectionSegment';
    readonly items?: ReadonlyArray<{
      readonly __typename?: 'InvestorFirmsGrid';
      readonly address1?: string | null;
      readonly address2?: string | null;
      readonly cik1?: string | null;
      readonly cik2?: string | null;
      readonly linkedCmgEntityKey?: string | null;
      readonly linkedCmgEntityName?: string | null;
      readonly crd?: string | null;
      readonly createdByUserName?: string | null;
      readonly createdOn: string;
      readonly description?: string | null;
      readonly emailAddress1?: string | null;
      readonly emailAddress2?: string | null;
      readonly factSet?: string | null;
      readonly fax1?: string | null;
      readonly fax2?: string | null;
      readonly firmKey?: string | null;
      readonly id: string;
      readonly firmSubType?: string | null;
      readonly firmType?: string | null;
      readonly isOnPlatform: boolean;
      readonly isLinked: boolean;
      readonly lei?: string | null;
      readonly modifiedByUserName?: string | null;
      readonly modifiedOn: string;
      readonly mpid?: string | null;
      readonly name: string;
      readonly phone1?: string | null;
      readonly phone2?: string | null;
      readonly status: Types.RolodexRecordStatus;
      readonly website1?: string | null;
      readonly website2?: string | null;
      readonly investorContactsCount: number;
      readonly salesCoverageCount: number;
      readonly investorContacts?: {
        readonly __typename?: 'InvestorContactsCollectionSegment';
        readonly items?: ReadonlyArray<{
          readonly __typename?: 'InvestorFirmContact';
          readonly investorEmployeeId: string;
          readonly name: string;
          readonly email1?: string | null;
        }> | null;
      } | null;
      readonly salesCoverage?: {
        readonly __typename?: 'SalesCoverageCollectionSegment';
        readonly items?: ReadonlyArray<{
          readonly __typename?: 'InvestorFirmRelationship';
          readonly employeeName?: string | null;
        }> | null;
      } | null;
    }> | null;
  } | null;
};

export type InvestorFirms_UpdateInvestorFirmMutationVariables = Types.Exact<{
  firmKeyOrId: Types.Scalars['ID']['input'];
  input: Types.UpdateInvestorFirmInput;
}>;

export type InvestorFirms_UpdateInvestorFirmMutation = {
  readonly __typename?: 'Mutation';
  readonly updateInvestorFirm: {
    readonly __typename?: 'UpdateInvestorFirmPayload';
    readonly investorFirmsGrid?: {
      readonly __typename?: 'InvestorFirmsGrid';
      readonly id: string;
      readonly firmKey?: string | null;
      readonly name: string;
      readonly firmType?: string | null;
      readonly firmSubType?: string | null;
      readonly cik1?: string | null;
      readonly cik2?: string | null;
      readonly crd?: string | null;
      readonly lei?: string | null;
      readonly factSet?: string | null;
      readonly description?: string | null;
      readonly website1?: string | null;
      readonly website2?: string | null;
      readonly address1?: string | null;
      readonly address2?: string | null;
      readonly emailAddress1?: string | null;
      readonly emailAddress2?: string | null;
      readonly phone1?: string | null;
      readonly phone2?: string | null;
      readonly fax1?: string | null;
      readonly fax2?: string | null;
      readonly status: Types.RolodexRecordStatus;
      readonly modifiedOn: string;
      readonly modifiedByUserName?: string | null;
    } | null;
  };
};

export type InvestorFirms_AdminUpdateInvestorFirmMutationVariables = Types.Exact<{
  input: Types.AdminUpdateInvestorFirmInput;
}>;

export type InvestorFirms_AdminUpdateInvestorFirmMutation = {
  readonly __typename?: 'Mutation';
  readonly adminUpdateInvestorFirm?: {
    readonly __typename?: 'AdminUpdateInvestorFirmPayload';
    readonly investorFirmsGrid?: {
      readonly __typename?: 'InvestorFirmsGrid';
      readonly id: string;
      readonly firmKey?: string | null;
      readonly name: string;
      readonly firmType?: string | null;
      readonly firmSubType?: string | null;
      readonly cik1?: string | null;
      readonly cik2?: string | null;
      readonly crd?: string | null;
      readonly lei?: string | null;
      readonly factSet?: string | null;
      readonly description?: string | null;
      readonly website1?: string | null;
      readonly website2?: string | null;
      readonly address1?: string | null;
      readonly address2?: string | null;
      readonly emailAddress1?: string | null;
      readonly emailAddress2?: string | null;
      readonly phone1?: string | null;
      readonly phone2?: string | null;
      readonly fax1?: string | null;
      readonly fax2?: string | null;
      readonly status: Types.RolodexRecordStatus;
      readonly modifiedOn: string;
      readonly modifiedByUserName?: string | null;
    } | null;
  } | null;
};

export type InvestorFirms_InvestorFirmFragment = {
  readonly __typename?: 'InvestorFirmsGrid';
  readonly id: string;
  readonly firmKey?: string | null;
  readonly name: string;
  readonly firmType?: string | null;
  readonly firmSubType?: string | null;
  readonly cik1?: string | null;
  readonly cik2?: string | null;
  readonly crd?: string | null;
  readonly lei?: string | null;
  readonly factSet?: string | null;
  readonly description?: string | null;
  readonly website1?: string | null;
  readonly website2?: string | null;
  readonly address1?: string | null;
  readonly address2?: string | null;
  readonly emailAddress1?: string | null;
  readonly emailAddress2?: string | null;
  readonly phone1?: string | null;
  readonly phone2?: string | null;
  readonly fax1?: string | null;
  readonly fax2?: string | null;
  readonly status: Types.RolodexRecordStatus;
  readonly modifiedOn: string;
  readonly modifiedByUserName?: string | null;
};

export const InvestorFirms_AddInvestorFirmDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'InvestorFirms_AddInvestorFirm' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateInvestorFirmInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createInvestorFirm' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'investorFirmsGrid' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'InvestorFirms_InvestorFirm' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InvestorFirms_InvestorFirm' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InvestorFirmsGrid' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmSubType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cik1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cik2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'crd' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lei' } },
          { kind: 'Field', name: { kind: 'Name', value: 'factSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'website1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'website2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emailAddress1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emailAddress2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fax1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fax2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'modifiedOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'modifiedByUserName' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type InvestorFirms_AddInvestorFirmMutationFn = Apollo.MutationFunction<
  InvestorFirms_AddInvestorFirmMutation,
  InvestorFirms_AddInvestorFirmMutationVariables
>;

/**
 * __useInvestorFirms_AddInvestorFirmMutation__
 *
 * To run a mutation, you first call `useInvestorFirms_AddInvestorFirmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvestorFirms_AddInvestorFirmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [investorFirmsAddInvestorFirmMutation, { data, loading, error }] = useInvestorFirms_AddInvestorFirmMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInvestorFirms_AddInvestorFirmMutation(
  baseOptions?: Apollo.MutationHookOptions<
    InvestorFirms_AddInvestorFirmMutation,
    InvestorFirms_AddInvestorFirmMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    InvestorFirms_AddInvestorFirmMutation,
    InvestorFirms_AddInvestorFirmMutationVariables
  >(InvestorFirms_AddInvestorFirmDocument, options);
}
export type InvestorFirms_AddInvestorFirmMutationHookResult = ReturnType<
  typeof useInvestorFirms_AddInvestorFirmMutation
>;
export type InvestorFirms_AddInvestorFirmMutationResult =
  Apollo.MutationResult<InvestorFirms_AddInvestorFirmMutation>;
export type InvestorFirms_AddInvestorFirmMutationOptions = Apollo.BaseMutationOptions<
  InvestorFirms_AddInvestorFirmMutation,
  InvestorFirms_AddInvestorFirmMutationVariables
>;
export const InvestorFirms_AdminAddInvestorFirmDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'InvestorFirms_AdminAddInvestorFirm' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AdminCreateInvestorFirmInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adminCreateInvestorFirm' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'investorFirmsGrid' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'InvestorFirms_InvestorFirm' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InvestorFirms_InvestorFirm' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InvestorFirmsGrid' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmSubType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cik1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cik2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'crd' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lei' } },
          { kind: 'Field', name: { kind: 'Name', value: 'factSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'website1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'website2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emailAddress1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emailAddress2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fax1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fax2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'modifiedOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'modifiedByUserName' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type InvestorFirms_AdminAddInvestorFirmMutationFn = Apollo.MutationFunction<
  InvestorFirms_AdminAddInvestorFirmMutation,
  InvestorFirms_AdminAddInvestorFirmMutationVariables
>;

/**
 * __useInvestorFirms_AdminAddInvestorFirmMutation__
 *
 * To run a mutation, you first call `useInvestorFirms_AdminAddInvestorFirmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvestorFirms_AdminAddInvestorFirmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [investorFirmsAdminAddInvestorFirmMutation, { data, loading, error }] = useInvestorFirms_AdminAddInvestorFirmMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInvestorFirms_AdminAddInvestorFirmMutation(
  baseOptions?: Apollo.MutationHookOptions<
    InvestorFirms_AdminAddInvestorFirmMutation,
    InvestorFirms_AdminAddInvestorFirmMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    InvestorFirms_AdminAddInvestorFirmMutation,
    InvestorFirms_AdminAddInvestorFirmMutationVariables
  >(InvestorFirms_AdminAddInvestorFirmDocument, options);
}
export type InvestorFirms_AdminAddInvestorFirmMutationHookResult = ReturnType<
  typeof useInvestorFirms_AdminAddInvestorFirmMutation
>;
export type InvestorFirms_AdminAddInvestorFirmMutationResult =
  Apollo.MutationResult<InvestorFirms_AdminAddInvestorFirmMutation>;
export type InvestorFirms_AdminAddInvestorFirmMutationOptions = Apollo.BaseMutationOptions<
  InvestorFirms_AdminAddInvestorFirmMutation,
  InvestorFirms_AdminAddInvestorFirmMutationVariables
>;
export const CrmManagement_InvestorFirms_InvestorFirmDetailDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CrmManagement_InvestorFirms_InvestorFirmDetail' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'firmId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'investorFirmsGrid' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'firmId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'InvestorFirm' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InvestorFirm' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InvestorFirmsGrid' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cik1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cik2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkedCmgEntityKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkedCmgEntityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'crd' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdByUserName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emailAddress1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emailAddress2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'factSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fax1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fax2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmSubType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isOnPlatform' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isLinked' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lei' } },
          { kind: 'Field', name: { kind: 'Name', value: 'modifiedByUserName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'modifiedOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mpid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'website1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'website2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'investorContactsCount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'investorContacts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'status' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'EnumValue', value: 'EFFECTIVE' },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'InvestorContact' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'salesCoverageCount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'salesCoverage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'employeeName' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InvestorContact' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InvestorFirmContact' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'investorEmployeeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email1' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useCrmManagement_InvestorFirms_InvestorFirmDetailQuery__
 *
 * To run a query within a React component, call `useCrmManagement_InvestorFirms_InvestorFirmDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrmManagement_InvestorFirms_InvestorFirmDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrmManagement_InvestorFirms_InvestorFirmDetailQuery({
 *   variables: {
 *      firmId: // value for 'firmId'
 *   },
 * });
 */
export function useCrmManagement_InvestorFirms_InvestorFirmDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    CrmManagement_InvestorFirms_InvestorFirmDetailQuery,
    CrmManagement_InvestorFirms_InvestorFirmDetailQueryVariables
  > &
    (
      | { variables: CrmManagement_InvestorFirms_InvestorFirmDetailQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CrmManagement_InvestorFirms_InvestorFirmDetailQuery,
    CrmManagement_InvestorFirms_InvestorFirmDetailQueryVariables
  >(CrmManagement_InvestorFirms_InvestorFirmDetailDocument, options);
}
export function useCrmManagement_InvestorFirms_InvestorFirmDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CrmManagement_InvestorFirms_InvestorFirmDetailQuery,
    CrmManagement_InvestorFirms_InvestorFirmDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CrmManagement_InvestorFirms_InvestorFirmDetailQuery,
    CrmManagement_InvestorFirms_InvestorFirmDetailQueryVariables
  >(CrmManagement_InvestorFirms_InvestorFirmDetailDocument, options);
}
// @ts-ignore
export function useCrmManagement_InvestorFirms_InvestorFirmDetailSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CrmManagement_InvestorFirms_InvestorFirmDetailQuery,
    CrmManagement_InvestorFirms_InvestorFirmDetailQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  CrmManagement_InvestorFirms_InvestorFirmDetailQuery,
  CrmManagement_InvestorFirms_InvestorFirmDetailQueryVariables
>;
export function useCrmManagement_InvestorFirms_InvestorFirmDetailSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CrmManagement_InvestorFirms_InvestorFirmDetailQuery,
        CrmManagement_InvestorFirms_InvestorFirmDetailQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  CrmManagement_InvestorFirms_InvestorFirmDetailQuery | undefined,
  CrmManagement_InvestorFirms_InvestorFirmDetailQueryVariables
>;
export function useCrmManagement_InvestorFirms_InvestorFirmDetailSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CrmManagement_InvestorFirms_InvestorFirmDetailQuery,
        CrmManagement_InvestorFirms_InvestorFirmDetailQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CrmManagement_InvestorFirms_InvestorFirmDetailQuery,
    CrmManagement_InvestorFirms_InvestorFirmDetailQueryVariables
  >(CrmManagement_InvestorFirms_InvestorFirmDetailDocument, options);
}
export type CrmManagement_InvestorFirms_InvestorFirmDetailQueryHookResult = ReturnType<
  typeof useCrmManagement_InvestorFirms_InvestorFirmDetailQuery
>;
export type CrmManagement_InvestorFirms_InvestorFirmDetailLazyQueryHookResult = ReturnType<
  typeof useCrmManagement_InvestorFirms_InvestorFirmDetailLazyQuery
>;
export type CrmManagement_InvestorFirms_InvestorFirmDetailSuspenseQueryHookResult = ReturnType<
  typeof useCrmManagement_InvestorFirms_InvestorFirmDetailSuspenseQuery
>;
export type CrmManagement_InvestorFirms_InvestorFirmDetailQueryResult = Apollo.QueryResult<
  CrmManagement_InvestorFirms_InvestorFirmDetailQuery,
  CrmManagement_InvestorFirms_InvestorFirmDetailQueryVariables
>;
export const CrmManagement_InvestorFirms_AdminInvestorFirmDetailDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CrmManagement_InvestorFirms_AdminInvestorFirmDetail' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'firmId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adminInvestorFirmsGrid' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'firmId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'InvestorFirm' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InvestorFirm' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InvestorFirmsGrid' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cik1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cik2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkedCmgEntityKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkedCmgEntityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'crd' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdByUserName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emailAddress1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emailAddress2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'factSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fax1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fax2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmSubType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isOnPlatform' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isLinked' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lei' } },
          { kind: 'Field', name: { kind: 'Name', value: 'modifiedByUserName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'modifiedOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mpid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'website1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'website2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'investorContactsCount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'investorContacts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'status' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'EnumValue', value: 'EFFECTIVE' },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'InvestorContact' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'salesCoverageCount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'salesCoverage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'employeeName' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InvestorContact' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InvestorFirmContact' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'investorEmployeeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email1' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useCrmManagement_InvestorFirms_AdminInvestorFirmDetailQuery__
 *
 * To run a query within a React component, call `useCrmManagement_InvestorFirms_AdminInvestorFirmDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrmManagement_InvestorFirms_AdminInvestorFirmDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrmManagement_InvestorFirms_AdminInvestorFirmDetailQuery({
 *   variables: {
 *      firmId: // value for 'firmId'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useCrmManagement_InvestorFirms_AdminInvestorFirmDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    CrmManagement_InvestorFirms_AdminInvestorFirmDetailQuery,
    CrmManagement_InvestorFirms_AdminInvestorFirmDetailQueryVariables
  > &
    (
      | {
          variables: CrmManagement_InvestorFirms_AdminInvestorFirmDetailQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CrmManagement_InvestorFirms_AdminInvestorFirmDetailQuery,
    CrmManagement_InvestorFirms_AdminInvestorFirmDetailQueryVariables
  >(CrmManagement_InvestorFirms_AdminInvestorFirmDetailDocument, options);
}
export function useCrmManagement_InvestorFirms_AdminInvestorFirmDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CrmManagement_InvestorFirms_AdminInvestorFirmDetailQuery,
    CrmManagement_InvestorFirms_AdminInvestorFirmDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CrmManagement_InvestorFirms_AdminInvestorFirmDetailQuery,
    CrmManagement_InvestorFirms_AdminInvestorFirmDetailQueryVariables
  >(CrmManagement_InvestorFirms_AdminInvestorFirmDetailDocument, options);
}
// @ts-ignore
export function useCrmManagement_InvestorFirms_AdminInvestorFirmDetailSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CrmManagement_InvestorFirms_AdminInvestorFirmDetailQuery,
    CrmManagement_InvestorFirms_AdminInvestorFirmDetailQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  CrmManagement_InvestorFirms_AdminInvestorFirmDetailQuery,
  CrmManagement_InvestorFirms_AdminInvestorFirmDetailQueryVariables
>;
export function useCrmManagement_InvestorFirms_AdminInvestorFirmDetailSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CrmManagement_InvestorFirms_AdminInvestorFirmDetailQuery,
        CrmManagement_InvestorFirms_AdminInvestorFirmDetailQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  CrmManagement_InvestorFirms_AdminInvestorFirmDetailQuery | undefined,
  CrmManagement_InvestorFirms_AdminInvestorFirmDetailQueryVariables
>;
export function useCrmManagement_InvestorFirms_AdminInvestorFirmDetailSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CrmManagement_InvestorFirms_AdminInvestorFirmDetailQuery,
        CrmManagement_InvestorFirms_AdminInvestorFirmDetailQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CrmManagement_InvestorFirms_AdminInvestorFirmDetailQuery,
    CrmManagement_InvestorFirms_AdminInvestorFirmDetailQueryVariables
  >(CrmManagement_InvestorFirms_AdminInvestorFirmDetailDocument, options);
}
export type CrmManagement_InvestorFirms_AdminInvestorFirmDetailQueryHookResult = ReturnType<
  typeof useCrmManagement_InvestorFirms_AdminInvestorFirmDetailQuery
>;
export type CrmManagement_InvestorFirms_AdminInvestorFirmDetailLazyQueryHookResult = ReturnType<
  typeof useCrmManagement_InvestorFirms_AdminInvestorFirmDetailLazyQuery
>;
export type CrmManagement_InvestorFirms_AdminInvestorFirmDetailSuspenseQueryHookResult = ReturnType<
  typeof useCrmManagement_InvestorFirms_AdminInvestorFirmDetailSuspenseQuery
>;
export type CrmManagement_InvestorFirms_AdminInvestorFirmDetailQueryResult = Apollo.QueryResult<
  CrmManagement_InvestorFirms_AdminInvestorFirmDetailQuery,
  CrmManagement_InvestorFirms_AdminInvestorFirmDetailQueryVariables
>;
export const InvestorFirms_UpdateInvestorFirmDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'InvestorFirms_UpdateInvestorFirm' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'firmKeyOrId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateInvestorFirmInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateInvestorFirm' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'firmKeyOrId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'firmKeyOrId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'investorFirmsGrid' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'InvestorFirms_InvestorFirm' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InvestorFirms_InvestorFirm' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InvestorFirmsGrid' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmSubType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cik1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cik2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'crd' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lei' } },
          { kind: 'Field', name: { kind: 'Name', value: 'factSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'website1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'website2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emailAddress1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emailAddress2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fax1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fax2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'modifiedOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'modifiedByUserName' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type InvestorFirms_UpdateInvestorFirmMutationFn = Apollo.MutationFunction<
  InvestorFirms_UpdateInvestorFirmMutation,
  InvestorFirms_UpdateInvestorFirmMutationVariables
>;

/**
 * __useInvestorFirms_UpdateInvestorFirmMutation__
 *
 * To run a mutation, you first call `useInvestorFirms_UpdateInvestorFirmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvestorFirms_UpdateInvestorFirmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [investorFirmsUpdateInvestorFirmMutation, { data, loading, error }] = useInvestorFirms_UpdateInvestorFirmMutation({
 *   variables: {
 *      firmKeyOrId: // value for 'firmKeyOrId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInvestorFirms_UpdateInvestorFirmMutation(
  baseOptions?: Apollo.MutationHookOptions<
    InvestorFirms_UpdateInvestorFirmMutation,
    InvestorFirms_UpdateInvestorFirmMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    InvestorFirms_UpdateInvestorFirmMutation,
    InvestorFirms_UpdateInvestorFirmMutationVariables
  >(InvestorFirms_UpdateInvestorFirmDocument, options);
}
export type InvestorFirms_UpdateInvestorFirmMutationHookResult = ReturnType<
  typeof useInvestorFirms_UpdateInvestorFirmMutation
>;
export type InvestorFirms_UpdateInvestorFirmMutationResult =
  Apollo.MutationResult<InvestorFirms_UpdateInvestorFirmMutation>;
export type InvestorFirms_UpdateInvestorFirmMutationOptions = Apollo.BaseMutationOptions<
  InvestorFirms_UpdateInvestorFirmMutation,
  InvestorFirms_UpdateInvestorFirmMutationVariables
>;
export const InvestorFirms_AdminUpdateInvestorFirmDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'InvestorFirms_AdminUpdateInvestorFirm' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AdminUpdateInvestorFirmInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adminUpdateInvestorFirm' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'investorFirmsGrid' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'InvestorFirms_InvestorFirm' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InvestorFirms_InvestorFirm' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InvestorFirmsGrid' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmSubType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cik1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cik2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'crd' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lei' } },
          { kind: 'Field', name: { kind: 'Name', value: 'factSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'website1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'website2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emailAddress1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emailAddress2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fax1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fax2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'modifiedOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'modifiedByUserName' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type InvestorFirms_AdminUpdateInvestorFirmMutationFn = Apollo.MutationFunction<
  InvestorFirms_AdminUpdateInvestorFirmMutation,
  InvestorFirms_AdminUpdateInvestorFirmMutationVariables
>;

/**
 * __useInvestorFirms_AdminUpdateInvestorFirmMutation__
 *
 * To run a mutation, you first call `useInvestorFirms_AdminUpdateInvestorFirmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvestorFirms_AdminUpdateInvestorFirmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [investorFirmsAdminUpdateInvestorFirmMutation, { data, loading, error }] = useInvestorFirms_AdminUpdateInvestorFirmMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInvestorFirms_AdminUpdateInvestorFirmMutation(
  baseOptions?: Apollo.MutationHookOptions<
    InvestorFirms_AdminUpdateInvestorFirmMutation,
    InvestorFirms_AdminUpdateInvestorFirmMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    InvestorFirms_AdminUpdateInvestorFirmMutation,
    InvestorFirms_AdminUpdateInvestorFirmMutationVariables
  >(InvestorFirms_AdminUpdateInvestorFirmDocument, options);
}
export type InvestorFirms_AdminUpdateInvestorFirmMutationHookResult = ReturnType<
  typeof useInvestorFirms_AdminUpdateInvestorFirmMutation
>;
export type InvestorFirms_AdminUpdateInvestorFirmMutationResult =
  Apollo.MutationResult<InvestorFirms_AdminUpdateInvestorFirmMutation>;
export type InvestorFirms_AdminUpdateInvestorFirmMutationOptions = Apollo.BaseMutationOptions<
  InvestorFirms_AdminUpdateInvestorFirmMutation,
  InvestorFirms_AdminUpdateInvestorFirmMutationVariables
>;
